import styled from 'styled-components';

export const Canvas = styled.canvas`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  opacity: ${({ theme }) => (theme.light ? 1 : 0.5)};
  transition: opacity 0.4s ease;
`;
